import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Algo tan simple me lo cambió todo.',
  text: 'Llegué a pensar que lo mío era crónico. En la Fase 1, al tercer día el primer paso de la mañana ya era diferente. Semana 3: volví a picar sin pensarlo. Día 28: dos partidos completos.',
  author: 'Rodrigo M.',
  detail: '42 · Fútbol · Córdoba',
  image: 'https://cdn.magicpatterns.com/uploads/2fad8seUuBKdGCVbfBh8we/ebook_testimonio_2.png'
}, {
  quote: 'Mi pie estaba dormido, no roto.',
  text: 'Un cajón lleno de plantillas inútiles. Cuando hice el primer ejercicio de activación y me tembló la pierna, entendí todo. Hoy bajo la escalera apoyando bien el talón.',
  author: 'Marcelo T.',
  detail: '51 · Running · Rosario',
  image: 'https://cdn.magicpatterns.com/uploads/1axBgRemVQqF6HYmPrvxtV/ebook_testimonio_3.png'
}, {
  quote: 'Finalmente alguien atacó el problema de verdad.',
  text: 'Con el precio de una sesión de kinesio me llevé todo el protocolo. En 15 min/día, sin salir de casa, resultados reales. Día 20: parada media hora sin cambiar el peso de pie.',
  author: 'Claudia R.',
  detail: '47 · Deportista amateur · Buenos Aires',
  image: 'https://cdn.magicpatterns.com/uploads/cETLoQY8Uzrg4YGxmiSDtC/ebook_testimonio_1_.png'
}];
export function SocialProof() {
  return <section className="py-6 md:py-10 px-4 bg-dark-card" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-181">
          Resultados <span className="text-neon" data-id="element-182">Reales</span>
        </motion.h2>

        <div className="space-y-3" data-id="element-183">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-dark border border-dark-border rounded-xl p-4" data-id="element-184">
              <div className="flex items-center gap-1 mb-2" data-id="element-185">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-neon text-neon" data-id="element-186" />)}
              </div>
              <h4 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-187">
                "{t.quote}"
              </h4>
              <p className="text-white text-base md:text-lg leading-relaxed mb-3" data-id="element-188">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-dark-border" data-id="element-189">
                <div className="w-10 h-10 rounded-full border border-neon/20 overflow-hidden shrink-0" data-id="element-190">
                  <img src={t.image} alt={t.author} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-191" />
                </div>
                <div data-id="element-192">
                  <div className="font-bold text-white text-base" data-id="element-193">
                    {t.author}
                  </div>
                  <div className="text-base text-neon" data-id="element-194">{t.detail}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}